<template>
  <div class="tooltip-container">
    <slot name="trigger" />
    <div class="tooltip-content" :style="getStyles()">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: () => 'auto',
    },
  },
  methods: {
    getStyles() {
      const buttonWidth = typeof this.width === 'string' ? this.width : `${this.width}px`;

      return { width: buttonWidth };
    },
  },
};
</script>

<style lang="sass" scoped>
  .tooltip-container
    position: relative

    &:hover
      .tooltip-content
        display: block

  .tooltip-content
    display: none
    position: absolute
    right: -15px
    bottom: 30px
    padding: 10px
    font-size: 12px
    line-height: 15px
    font-weight: 400
    color: #212121
    background: #fff
    border-radius: 5px
    z-index: 1000

    &:after
      content: ''
      position: absolute
      right: 10%
      bottom: -20px
      border: 10px solid transparent
      border-top: 10px solid #fff
</style>
